import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { SavedConfigType, SaveType } from "../../../../shared-logic/types/SaveTypes";

export type SaveStateType = SaveType;

export const initialState: SaveStateType = {
    saving: false,
    saved: false,
    qrCode: "",
    passbookUrl: "",
    passbookImage: "",
    error: false,
    data: null,
};

export type CarConfigSaveActionsTypes = ReturnType<
    | typeof startConfigSave
    | typeof finishConfigSave
    | typeof errorConfigSave
    | typeof resetSavedState
    | typeof invalidateConfigSave
>;

export const CarConfigSaveSlice = createSlice({
    name: "save",
    initialState,
    reducers: {
        startConfigSave(state) {
            return {
                ...state,
                error: false,
            };
        },
        finishConfigSave(state, action: PayloadAction<{ data: SavedConfigType; qrCode?: string }>) {
            return {
                ...state,
                saving: false,
                saved: true,
                qrCode: action.payload.qrCode || "",
                data: action.payload.data,
            };
        },
        errorConfigSave(state) {
            return {
                ...state,
                error: true,
            };
        },
        resetSavedState(state) {
            return { ...state, saved: false };
        },
        invalidateConfigSave() {
            return initialState;
        },
    },
});

export const { startConfigSave, finishConfigSave, errorConfigSave, resetSavedState, invalidateConfigSave } =
    CarConfigSaveSlice.actions;
